import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import {
  ThirdPartyTypeEnum,
  getFragmentData,
  graphql,
} from '@e-socna/data-layer';
import type { FragmentType } from '@e-socna/data-layer';

import { ThirdPartyCard } from './ThirdPartyCard';
import { NoData } from './Illustrations/NoData';
import type { OrganizationCardCmp_Organization_Fragment } from './ThirdPartyCard/OrganizationCard';
import type { PersonCardCmp_Person_Fragment } from './ThirdPartyCard/PersonCard';

export const BillingCmp_ThirdParty_Fragment = graphql(`
  fragment BillingCmp_ThirdParty_Fragment on ThirdParty {
    billReceiver {
      kind
      ... on Person {
        ...PersonCardCmp_Person_Fragment
      }
      ... on Organization {
        ...OrganizationCardCmp_Organization_Fragment
      }
    }
    billEmitters {
      _id
      kind
      ... on Person {
        ...PersonCardCmp_Person_Fragment
      }
      ... on Organization {
        ...OrganizationCardCmp_Organization_Fragment
      }
    }
  }
`);

interface Props {
  readonly thirdParty: FragmentType<typeof BillingCmp_ThirdParty_Fragment>;
}

export const Billing = ({ thirdParty: pThirdParty }: Readonly<Props>) => {
  const thirdParty = getFragmentData(
    BillingCmp_ThirdParty_Fragment,
    pThirdParty,
  );

  const { billReceiver, billEmitters } = thirdParty;

  if (!billReceiver && !billEmitters.length) {
    return <NoData />;
  }

  return (
    <Box sx={{ pt: 4, width: '100%' }}>
      <Grid container spacing={2}>
        <Grid
          size={{
            md: 6,
            xs: 12,
          }}
        >
          <Typography
            component="h2"
            gutterBottom
            sx={{ pt: { xs: 4, md: 0 }, pb: 2 }}
            variant="h5"
          >
            Reçoit depuis
          </Typography>
          {!billEmitters.length ? (
            <NoData />
          ) : (
            <Grid container size={12} spacing={2}>
              {billEmitters.map((billEmitter) => (
                <ThirdPartyCard
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...(billEmitter.kind === ThirdPartyTypeEnum.Organization
                    ? {
                        organization: billEmitter as FragmentType<
                          typeof OrganizationCardCmp_Organization_Fragment
                        >,
                        person: undefined,
                      }
                    : {
                        person: billEmitter as FragmentType<
                          typeof PersonCardCmp_Person_Fragment
                        >,
                        organization: undefined,
                      })}
                  key={billEmitter._id}
                />
              ))}
            </Grid>
          )}
        </Grid>
        <Grid
          size={{
            md: 6,
            xs: 12,
          }}
        >
          <Typography component="h2" gutterBottom sx={{ pb: 2 }} variant="h5">
            Émet vers
          </Typography>
          {!billReceiver ? (
            <NoData />
          ) : (
            <Grid container size={12} spacing={2}>
              <ThirdPartyCard
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...(billReceiver.kind === ThirdPartyTypeEnum.Organization
                  ? {
                      organization: billReceiver as FragmentType<
                        typeof OrganizationCardCmp_Organization_Fragment
                      >,
                    }
                  : {
                      person: billReceiver as FragmentType<
                        typeof PersonCardCmp_Person_Fragment
                      >,
                    })}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
